export const DemolitionB4NavOptions = [
  {
    label: 'a) potřeby a spotřeby rozhodujících médií',
    target: 'b4.demolitionOrganization.mediaNeeds',
  },
  {
    label: 'b) odvodnění staveniště',
    target: 'b4.demolitionOrganization.siteDrainage',
  },
  {
    label: 'c) napojení staveniště na stávající infrastrukturu',
    target: 'b4.demolitionOrganization.siteConnection',
  },
  {
    label: 'd) vliv odstraňování staveb na okolí',
    target: 'b4.demolitionOrganization.impactOnSurroundings',
  },
  {
    label: 'e) maximální zábory',
    target: 'b4.demolitionOrganization.maximumOccupancy',
  },
  {
    label: 'f) požadavky na obchozí trasy',
    target: 'b4.demolitionOrganization.accessibilityRequirements',
  },
  {
    label: 'g) nakládání s odpady',
    target: 'b4.demolitionOrganization.wasteManagement',
  },
  {
    label: 'h) ochrana životního prostředí',
    target: 'b4.demolitionOrganization.environmentalProtection',
  },
  {
    label: 'i) zásady bezpečnosti a ochrany zdraví',
    target: 'b4.demolitionOrganization.safetyPrinciples',
  },
  {
    label: 'j) úpravy pro bezbariérové užívání',
    target: 'b4.demolitionOrganization.barrierFreeModifications',
  },
  {
    label: 'k) zásady pro dopravně inženýrská opatření',
    target: 'b4.demolitionOrganization.trafficMeasures',
  },
];
